'use client';

import { useTranslations } from '@power-core/toolkit';
import { type FunctionComponent, useState } from 'react';

import { useNavigation } from '@/modules/utils/custom-hooks/use-navigation';
import { getErrorMessage } from '@/modules/utils/get-error-message';
import { Button } from '@/ui-components/button/button';
import { Flexbox } from '@/ui-components/flexbox/flexbox';
import { Input } from '@/ui-components/input/input';
import { Modal } from '@/ui-components/modal/modal';
import { useDocumentApi } from '../hooks/use-document-api';

export const ProjectDocumentModal: FunctionComponent = () => {
	const { getSearchParams } = useNavigation();
	const { title, id: documentId } = getSearchParams();
	const { updateProjectDocument, isPending } = useDocumentApi();
	const [projectDocumentName, setProjectDocumentName] = useState(title ?? '');
	const [error, setError] = useState({ message: '', details: '' });

	const t = useTranslations();

	const onSave = () => {
		if (documentId)
			updateProjectDocument.mutateAsync({ body: { name: projectDocumentName }, projectDocumentId: documentId }).catch((err) => {
				setError({ message: t(getErrorMessage(err)), details: 'title' });
			});
	};

	return (
		<Modal name='ProjectDocumentModal' title={{ text: t('T_EDIT_PROJECT_DOCUMENT'), variant: 'h5' }} dismissible closeButton>
			<Flexbox direction='col' className='min-h-[160px]'>
				<Input
					label={t('T_PROJECT_DOCUMENT_NAME')}
					value={projectDocumentName}
					name='projectDocumentName'
					sizing='small'
					placeholder={t('T_ENTER_PROJECT_DOCUMENT_NAME')}
					onChange={(e) => {
						setProjectDocumentName(e.target.value);
						setError({ message: '', details: '' });
					}}
					onKeyUp={(e) => (e.key === 'Enter' ? onSave() : undefined)}
					containerClassname='w-full'
					error={error.details === 'title' ? error.message : null}
				/>
				<Flexbox justify='end' className='mt-10'>
					<Button
						onClick={onSave}
						variant='primary'
						sizing='small'
						className='w-32'
						isLoading={isPending}
						disabled={!projectDocumentName || isPending}
					>
						{documentId ? t('T_EDIT') : t('T_ADD')}
					</Button>
				</Flexbox>
			</Flexbox>
		</Modal>
	);
};
